import { useTranslation } from 'react-i18next'

import {
  EMPTY_STRING,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../../constants/common'
import { useOutboundUuid } from '../../../../hooks'
import { Divider } from '../../../Divider'
import Text from '../../../Text'
import {
  ProfileBuildingsWidgetItem,
  ProfileFlatsWidgetItem,
  Widget,
} from '../../../Widget'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import { AddressContentItem } from './AddressContentItem'
import { isNeedToShowAddressWidgetItemIcons } from './RequestProfileWidgetAddress.utils'

import * as styles from './RequestProfileWidgetAddress.module.css'

function RequestProfileWidgetAddress({ isSkeleton, requestData }) {
  const { t } = useTranslation()

  const outboundUuid = useOutboundUuid()

  const isConnectedRequest = Boolean(outboundUuid)

  const entrance = String(requestData?.flat?.entrance ?? EMPTY_STRING)

  const floor = String(requestData?.flat?.floor ?? EMPTY_STRING)

  return (
    <Widget
      contentContainerProps={{
        className: styles.content,
        skeletonProps: { className: styles.skeleton },
      }}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      isSkeleton={isSkeleton}
      qaName={RequestProfileWidgetKey.ADDRESS}
      title={t('RequestProfile.WidgetAddressTitleKey')}
    >
      <div className={styles.addressContent}>
        <div className={styles.addressField}>
          <Text isSecondary className={styles.label}>
            {t('RequestProfile.AddressWidgetBuildingLabelKey')}
          </Text>
          <ProfileBuildingsWidgetItem
            blocked={isConnectedRequest}
            isNeedToShowIcons={isNeedToShowAddressWidgetItemIcons}
            text={requestData?.building?.address?.value}
            tooltipAdditionalText={t('Common.ClickToOpenProfileKey')}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            value={requestData?.building?.id}
          />
        </div>
        {requestData?.flat ? (
          <>
            <Divider className={styles.divider} />
            <div className={styles.addressField}>
              <Text isSecondary className={styles.label}>
                {t('RequestProfile.AddressWidgetFlatLabelKey')}
              </Text>
              <ProfileFlatsWidgetItem
                blocked={isConnectedRequest}
                isNeedToShowIcons={isNeedToShowAddressWidgetItemIcons}
                text={`${t('Common.FlatSelectListItemNumberPrefixKey')} ${requestData?.flat.number}`}
                value={requestData?.flat.id}
              />
            </div>
          </>
        ) : null}
        {requestData?.flat?.entranceAddress ? (
          <AddressContentItem
            multiline
            label={t('RequestProfile.AddressWidgetEntranceAddressLabelKey')}
            value={requestData?.flat?.entranceAddress}
          />
        ) : null}
        {entrance ? (
          <AddressContentItem
            label={t('RequestProfile.AddressWidgetEntranceLabelKey')}
            value={entrance}
          />
        ) : null}
        {floor ? (
          <AddressContentItem
            label={t('RequestProfile.AddressWidgetFloorNumberLabelKey')}
            value={floor}
          />
        ) : null}
      </div>
    </Widget>
  )
}

export default RequestProfileWidgetAddress
